/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 * VisActionSupportBase
 * The VisActionSupportBase is the base for VisActionSupport classes
 *
 */
define([
	'jquery',
	'underscore',
	'../../lib/@waca/core-client/js/core-client/ui/core/Class'
], function(
	$,
	_,
	Class
) {
	'use strict';

	var VisActionSupportBase = Class.extend({

		init: function(params) {
			this.visAPI = params.visModel;
			this.pageContext = params.pageContext;
			this.ownerWidget = params.ownerWidget;
			this.logger = this.ownerWidget.logger;
			this.dashboard = params.ownerWidget.getDashboardApi();
		},

		_getFunction: function(prefix, name) {
			var fname = prefix + name;
			return this[fname] ? this[fname].bind(this) : null;
		},

		_isWidgetOfType: function(type) {
			return this.visAPI.getDefinition().id === type;
		}
	});

	return VisActionSupportBase;
});
